










































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import MemberOutstandingData from '@/data/MemberOutstandingData';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Vue {
  TableHead = MemberOutstandingData.TableHead;
}
